import React from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { ILiveWorkout } from '../../types'
import { DateTime } from 'luxon'
import { TaxRateResponse } from '../../context/TaxRateContext'
import { getDisplayPrice } from '../../services/currency-codes'

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
`
interface Props {
  openConfirmDialog: boolean
  setOpenConfirmDialog: (value: boolean) => void
  handleBuyClass: () => void
  purchasing: boolean
  workout: ILiveWorkout
  amount: number
  currency: string
  tax: TaxRateResponse | undefined
}

const ConfirmPurchaseModal = ({
  openConfirmDialog,
  setOpenConfirmDialog,
  purchasing,
  handleBuyClass,
  workout,
  amount,
  currency,
  tax,
}: Props) => {
  const taxPrice = (total: number) => {
    const { percentage } = tax
    return Math.round(total * (percentage / 100) * 100) / 100
  }

  const totalPrice = (total: number) => {
    if (!tax) {
      return total
    } else {
      return total + taxPrice(total)
    }
  }

  return (
    <Dialog
      open={openConfirmDialog}
      onClose={() => {
        if (purchasing) {
          return
        }
        setOpenConfirmDialog(false)
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        style={{ padding: 30, paddingBottom: 15 }}
      >
        Confirm Purchase
      </DialogTitle>
      <DialogContent
        style={{ padding: 30, paddingTop: 0, paddingBottom: 0, width: 400 }}
      >
        <DialogContentText id="alert-dialog-description">
          <b>{workout.title}</b>
          <br />
          with {workout.trainer.firstName} {workout.trainer.lastName}
          <br />
          {DateTime.fromISO(workout.startDate).toFormat('fff')}
          <br />
          <br />
          {tax ? (
            <>
              <PriceRow>
                <div>Subtotal</div>
                <div>{getDisplayPrice(amount, currency)}</div>
              </PriceRow>
              <PriceRow>
                <div>Tax</div>
                <div>{getDisplayPrice(taxPrice(amount), currency)}</div>
              </PriceRow>
              <PriceRow>
                <b>Total</b>
                <b>{getDisplayPrice(totalPrice(amount), currency)}</b>
              </PriceRow>
            </>
          ) : (
            <PriceRow>
              <b>Total</b>
              <b>{getDisplayPrice(totalPrice(amount), currency)}</b>
            </PriceRow>
          )}
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{ padding: 30, paddingTop: 15 }}>
        {/* <Button
          onClick={() => setOpenConfirmDialog(false)}
          color="primary"
          disabled={purchasing}
        >
          Cancel
        </Button> */}
        <Button
          onClick={handleBuyClass}
          color="primary"
          autoFocus
          variant="contained"
          fullWidth
          disabled={purchasing}
        >
          {purchasing ? 'Purchasing...' : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmPurchaseModal
